import { render, staticRenderFns } from "./salidaAdd.vue?vue&type=template&id=1c255cfc"
import script from "./salidaAdd.vue?vue&type=script&lang=js"
export * from "./salidaAdd.vue?vue&type=script&lang=js"
import style0 from "./salidaAdd.vue?vue&type=style&index=0&id=1c255cfc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports